<template>
    <div class="category-list">
        <el-collapse accordion>
            <draggable :list="categoryList" :options="categoryOpts" @change="handleOptionChange">
                <transition-group name="category">
                    <el-collapse-item v-for="(element, index) in categoryList" :key="element.id" class="category-item">
                        <template slot="title">
                            <div class="category-item-title">
                                <span class="category-item-content">
                                    <i class="el-icon-d-caret drag-handler"></i>
                                    <el-checkbox v-model="element.def" @change="handleDefaultItem(index)"></el-checkbox>
                                    <span class="ellipsis" style="width: 90px;">{{ element.title }}</span>
                                </span>
                                <div class="category-item-option" @click.stop="handleDeleteItem(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                            </div>
                        </template>
                        <template>
                            <div class="sel-content">
                                <div class="sel-content-item">
                                    <el-input v-model="element.title" size="mini" placeholder="请输入内容">
                                        <template slot="prepend">标&nbsp;&nbsp;&nbsp;题</template>
                                    </el-input>
                                </div>
                                <div class="sel-content-item">
                                    <el-input v-model="element.value" size="mini" placeholder="请输入内容">
                                        <template slot="prepend">取&nbsp;&nbsp;&nbsp;值</template>
                                    </el-input>
                                </div>
                                <div class="sel-content-item">
                                    <div class="left">
                                        <el-input v-model="element.ext1" size="mini" placeholder="选择字体色">
                                            <template slot="prepend">字体色</template>
                                        </el-input>
                                    </div>
                                    <div class="right">
                                        <el-color-picker v-model="element.ext1" show-alpha :predefine="predefineColors"></el-color-picker>
                                    </div>
                                </div>
                                <div class="sel-content-item">
                                    <div class="left">
                                        <el-input v-model="element.ext2" size="mini" placeholder="选择背景色">
                                            <template slot="prepend">背景色</template>
                                        </el-input>
                                    </div>
                                    <div class="right">
                                        <el-color-picker v-model="element.ext2" show-alpha :predefine="predefineColors"></el-color-picker>
                                    </div>
                                </div>
                                <div class="sel-content-item">
                                    <el-input v-model="element.serialNumberValue" size="mini" placeholder="请输入内容">
                                        <template slot="prepend">流水号取值</template>
                                    </el-input>
                                </div>
                                <div class="sel-content-item">
                                    <div class="left">
                                        <el-popover
                                          placement="top"
                                          width="500"
                                          trigger="click">
                                            <div v-if="!(field.type === 'category' && field.options.config.type === 'multi')">
                                                <div class="sel-content-item-line">
                                                    <el-select 
                                                      v-model="element.assignmentFieldId" 
                                                      clearable 
                                                      filterable
                                                      :multiple="false"
                                                      placeholder="请选择级联要赋值的字段" 
                                                    >
                                                        <el-option 
                                                            v-for="item in assignmentFormFieldList"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id"
                                                        />
                                                    </el-select>
                                                </div>
                                                <div class="sel-content-item-line">
                                                    <el-input v-model="element.assignmentFieldValue" placeholder="请输入要赋值的字段的值"></el-input>
                                                </div>
                                            </div>
                                            <el-button slot="reference">级联赋值</el-button>
                                        </el-popover>
                                        <el-popover
                                            placement="top"
                                            width="500"
                                            trigger="click">
                                              <div v-if="!(field.type === 'category' && field.options.config.type === 'multi')">
                                                  <div class="sel-content-item-line">
                                                      <el-input v-model="element.assignmentFieldValue" placeholder="请输入满足当前选项需要的规则"></el-input>
                                                  </div>
                                              </div>
                                              <el-button slot="reference">规则赋值</el-button>
                                          </el-popover>
                                    </div>
                                </div> 
                                <div v-if="!(field.type === 'category' && field.options.config.type === 'multi')" class="sel-content-item">
                                    <div class="left">
                                        <el-select 
                                          v-model="selectedCasFields[index]" 
                                          clearable 
                                          filterable
                                          :multiple="true"
                                          placeholder="请选择级联显示的字段" 
                                         @change="selectViewFormField(index)">
                                            <el-option 
                                                v-for="item in viewFormFieldList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            />
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-collapse-item>
                    <!-- <div v-for="element in categoryList" :key="element.value" class="category-item">
                        <span>
                            <i class="el-icon-d-caret drag-handler"></i>
                            <el-radio v-model="element.default" v-if="fieldType === 'single'"></el-radio>
                            <el-checkbox v-model="element.default" v-if="fieldType === 'multi'"></el-checkbox>
                            {{ element.title }}
                        </span>
                        <el-tooltip content="删除" placement="right">
                            <div class="category-item-delete"><i class="el-icon-delete"></i></div>
                        </el-tooltip>
                    </div> -->
                </transition-group>
            </draggable>
        </el-collapse>
        <el-button type="primary" icon="el-icon-circle-plus" @click="handleAddItem">添加</el-button>
    </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash';
import Draggable from 'vuedraggable';
import { getUUID } from '@/utils/grocer';
export default {
    components: {
        Draggable
    },
    data () {
        return {
            // categoryList: [],
            categoryOpts: {
                handle: '.drag-handler',
                group: {
                    name: 'categoryList'
                },
                sort: true
            },
            selectedCasFields: [],
            viewFormFieldList: [],
            assignmentFormFieldList: [],
            predefineColors: [
                '#ecf5ff',
                '#f0f9eb',
                '#f4f4f5',
                '#fdf6ec',
                '#fef0f0',
                '#409eff',
                '#67c23a',
                '#909399',
                '#e6a23c',
                '#f56c6c',
                '#ff4500',
                '#ff8c00',
                '#ffd700',
                '#90ee90',
                '#00ced1',
                '#c71585',
                'rgba(255, 69, 0, 0.68)',
                'rgb(255, 120, 0)',
                'hsva(120, 40, 94, 0.5)',
                'hsl(181, 100%, 37%)',
                'hsla(209, 100%, 56%, 0.73)'
            ],
            cacheCategoryList: []
        };
    },
    props: {
        categoryList: {
            type: Array,
            required: true
        },
        fieldType: {
            type: String,
            default: 'single'
        },
        field: {
            type: Object,
            required: true
        },
        fieldsList: {
            type: Array
        },
        relateModelList: {
            type: Array,
            default: []
        }
    },
    created () {
        this.initviewFormFieldList();
        this.cacheCategoryList = cloneDeep(this.categoryList);
    },
    methods: {
        async initviewFormFieldList () {
            this.viewFormFieldList = [];
            let fields = cloneDeep(this.fieldsList);
            for (let item of fields) {
                if (item.id !== this.field.id) {
                    // 当前表单其它字段id
                    this.viewFormFieldList.push(item);
                }
                if (item.type === 'text' || item.type === 'number' || item.type === 'calculation') {
                    this.assignmentFormFieldList.push(item);
                }
            }
            for (let i = 0, len = this.categoryList.length; i < len; i++) {
                this.selectedCasFields[i] = [];
                if (this.categoryList[i].ext3) {
                    this.selectedCasFields[i] = this.categoryList[i].ext3.split(',');
                }
            }
            // console.log(this.relateModelList);
            if (!isEmpty(this.relateModelList)) {
                let relateModelList = cloneDeep(this.relateModelList);
                for (let item of relateModelList) {
                    item.name = '[关联子表]-' + item.modelName;
                    this.viewFormFieldList.push(item);
                }
            }
            //  console.log(this.categoryList);
            //  console.log(this.selectedCasFields);
        },
        handleAddItem () {
            let uuid = getUUID(8, 16);
            this.categoryList.push({
                id: uuid,
                title: `选项${this.categoryList.length + 1}`,
                value: uuid,
                def: false
            });
            this.cacheCategoryList = cloneDeep(this.categoryList);
        },
        handleDeleteItem (index) {
            this.categoryList.splice(index, 1);
            this.cacheCategoryList = cloneDeep(this.categoryList);
        },
        handleDefaultItem (index) {
            if (this.fieldType === 'single') {
                // 单选模式，只能设置一个默认值
                for (let i = 0, len = this.categoryList.length; i < len; i++) {
                    if (i === index) {
                        continue;
                    } else {
                        this.categoryList[i].def = false;
                    }
                }
            }
        },
        selectViewFormField (index) {
            // console.log(this.field);
            if (!(this.field.type === 'category' && this.field.options.config.type === 'multi')) {
                let casAllMap = new Map();
                for (var m = 0; m < this.fieldsList.length; m++) { // 查出当前表单其它字段使用级联控制的情况，记录存储下来
                    let tempField = this.fieldsList[m];
                    if (tempField.type === 'select' || tempField.type === 'category') {
                        let allSelectedCasFields = tempField.options.config.options;
                        for (let i = 0; i < allSelectedCasFields.length; i++) { // 一维
                            let casFileds = allSelectedCasFields[i].ext3;
                            if (casFileds) {
                                let casFiledArr = casFileds.split(',');
                                for (let j = 0; j < casFiledArr.length; j++) { // 二维
                                    if (casAllMap.has(casFiledArr[j])) {
                                        casAllMap.get(casFiledArr[j]).set(tempField.id, casFiledArr[j]);
                                    } else {
                                        let keyFiledMap = new Map();
                                        keyFiledMap.set(tempField.id, casFiledArr[j]);
                                        casAllMap.set(casFiledArr[j], keyFiledMap);
                                    }
                                }
                            }
                        }
                    }
                }
                // console.log(casAllMap);
                let element = this.categoryList[index];
                // console.log(element);
                if (this.selectedCasFields[index]) {
                    element.ext3 = this.selectedCasFields[index].join(',');
                } else {
                    element.ext3 = '';
                    this.selectedCasFields[index] = [];
                }
                let casMap = new Map();
                for (let i = 0; i < this.selectedCasFields.length; i++) { // 一维
                    for (let j = 0; j < this.selectedCasFields[i].length; j++) { // 二维
                        // console.log(this.selectedCasFields[i][j]);
                        casMap.set(this.selectedCasFields[i][j], this.selectedCasFields[i][j]);
                    }
                }
                for (let k = 0; k < this.fieldsList.length; k++) {
                    if (casMap.has(this.fieldsList[k].id)) {
                        this.fieldsList[k].ext2 = '1';// 被别的组件选中作为级联组件
                    } else {
                        this.fieldsList[k].ext2 = '';
                        // 假如当前字段被其它字段作为级联控制，那么需要还原它的级联设置值为1
                        if (this.fieldsList[k].id !== this.field.id && casAllMap.has(this.fieldsList[k].id)) {
                            this.fieldsList[k].ext2 = '1';
                        }
                    }
                }
            }
        },
        handleOptionChange (changeObj) {
            this.buildExt3();
        },
        buildExt3 () {
            this.categoryList.forEach(element => {
                let cur = this.cacheCategoryList.find(obj => obj.id === element.id);
                if (cur.ext3) {
                    element.ext3 = cur.ext3;
                } else {
                    delete element.ext3;
                }
            });
            this.initviewFormFieldList();
        }
    }
};
</script>

<style lang="less">
    .category-list {
        display: flex;
        flex-direction: column;
        .sel-content{
            .sel-content-item{
                height: 35px;
                line-height: 35px;
                display: flex;
                .left{
                    flex: 9;
                }
                .right{
                    flex: 1;
                }
            }
        }
        .drag-handler {
            cursor: move;
            margin: 0 4px;
        }
        .category-item {
            margin: 10px 0;
            background-color: #f2f6ff;
            border: 1px solid #ececec;
            box-sizing: border-box;
            overflow: hidden;
            font-size: 12px;

            // display: flex;
        }

        .category-item:hover .category-item-option {
            display: block;
        }
        .category-item-option {
            display: none;
        }

        .category-item-title {
            display: flex;
            justify-content: space-between;
            align-content: center;
        }

        .category-item-content {
            flex: 1;

            display: flex;
            align-items: center;
        }

        .category-item-delete {
            margin: 0 5px 0 0;
            cursor: pointer;
        }

        .el-radio__label {
            padding-left: 2px;
        }
        .el-collapse-item__content {
            padding: 0 0 10px 10px;
        }
        .el-collapse {
            border: 0;
        }
        .el-collapse-item__header {
            height: inherit;
            line-height: inherit;
        }
        .el-collapse-item__arrow {
            line-height: inherit;
        }

        .el-collapse-item__content {
            padding: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FieldCategory/FieldCategory.vue